import { styled } from '@mui/material/styles';
import { CustomPopover } from '../custom-popover';

export const Wrapper = styled(CustomPopover)``;
